import dayjs from 'dayjs'

// 指導前準備の出所・確認日の表記. 年は出さない (属性の行・申し送りの脇に添える短い日付).
//   '2026-09-18'                → '9/18'
//   '2026-10-14T09:00:00+09:00' → '10/14'
// 読めない値・空は null (呼び出し側で日付を出さない).
export const formatMonthDay = (value: string | null | undefined) => {
  if (!value) return null
  const d = dayjs(value)
  return d.isValid() ? d.format('M/D') : null
}

// 監査を終えた時刻. '10/14 09:00'.
export const formatMonthDayTime = (value: string | null | undefined) => {
  if (!value) return null
  const d = dayjs(value)
  return d.isValid() ? d.format('M/D HH:mm') : null
}
